/**
 * Created by neo on 26.04.22.
 */
import { makeAutoObservable } from 'mobx';
import { Pageable } from '../../../Interfaces/Pageable';
import { HttpBackend } from '../../../../Services/Http/HttpBackend';
import { LocalizedNamedEntity, createLocalizedNamedEntity } from '../../../LocalizedNamedEntity';
import { MindfulnessProgramTemplateQueryRequest } from './MindfulnessProgramTemplateQueryRequest';

export type MindfulnessProgramTemplateCategory = LocalizedNamedEntity & {
  order: number;
  query: MindfulnessProgramTemplateQueryRequest;
};

export function createMindfulnessProgramTemplateCategory(json?: Partial<MindfulnessProgramTemplateCategory>): MindfulnessProgramTemplateCategory {
  const base = createLocalizedNamedEntity(json as any);
  return makeAutoObservable({
    ...base,
    order: json?.order ?? 0,
    query: json?.query ?? {},
  });
}

export const MindfulnessProgramTemplateCategoryApi = {
  find(request?: Pageable): Promise<MindfulnessProgramTemplateCategory[]> {
    return HttpBackend.get(`/coach-program/mindfulness/template/category`, request).then((res) =>
      (res ?? []).map((r: any) => createMindfulnessProgramTemplateCategory(r)),
    );
  },
};
